<template>
  <ul class="allergenes">
    <li v-if="product.isNew" class="allergene-icon new">
      <span>{{ $t("products.isANewProduct") }}</span>
    </li>
    <li v-if="product.isVegetarian" class="allergene-icon vegetarian">
      <span>{{ $t("products.isVegetarian") }}</span>
    </li>
    <li v-if="product.hasAltramuces" class="allergene-icon lupin">
      <span>{{ $t("products.containsLupin") }}</span>
    </li>
    <li v-if="product.hasApio" class="allergene-icon celery">
      <span>{{ $t("products.containsCelery") }}</span>
    </li>
    <li v-if="product.hasCacahuetes" class="allergene-icon peanuts">
      <span>{{ $t("products.containsPeanuts") }}</span>
    </li>
    <li v-if="product.hasCrustaceos" class="allergene-icon crustacean">
      <span>{{ $t("products.containsCrustacean") }}</span>
    </li>
    <li v-if="product.hasGluten" class="allergene-icon gluten">
      <span>{{ $t("products.containsGluten") }}</span>
    </li>
    <li v-if="product.hasHuevo" class="allergene-icon egg">
      <span>{{ $t("products.containsEgg") }}</span>
    </li>
    <li v-if="product.hasLacteos" class="allergene-icon milk">
      <span>{{ $t("products.containsMilk") }}</span>
    </li>
    <li v-if="product.hasMostaza" class="allergene-icon mustard">
      <span>{{ $t("products.containsMustard") }}</span>
    </li>
    <li v-if="product.hasPescado" class="allergene-icon fish">
      <span>{{ $t("products.containsFish") }}</span>
    </li>
    <li v-if="product.hasSesamo" class="allergene-icon sesame">
      <span>{{ $t("products.containsSesame") }}</span>
    </li>
    <li v-if="product.hasSoja" class="allergene-icon soy">
      <span>{{ $t("products.containsSoy") }}</span>
    </li>
    <li v-if="product.hasSulfitos" class="allergene-icon sulfite">
      <span>{{ $t("products.containsSulfite") }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Allergens",
  props: ["product"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
